import Controller from "../class.Controller.js";

/**
 * Stub class for actions.
 * I guess you could do stuff here for debugging.
 */
export default class Action extends Controller {
	constructor(options) {
		super(options);

		/**
		 * Assign a symbol to this action.
		 * A symbol is a unique identifier which is a combination
		 * of this object's pointer (its place in the self-paced document)
		 * and this object's context (its place in the current logical flow of the script).
		 *
		 * An example of something which would affect this context is a GoTo.
		 * A GoTo can jump to a place in the document we've already been,
		 * but logically is a new context, as the sequence of events which occurred to
		 * get to that part of the document is not the same as the first time we were there.
		 */
		this.symbol = this.runnerController.getPointerSymbol(
			this.pointer,
			this.context
		);

		/**
		 * Assign a pointer string to this action.
		 * This is just a unique string-based identifier using the same arguments.
		 * It's useful for us to be able to reference this string when we need to
		 * correlate elements on the page with this particular action.
		 * (e.g. when creating a button on the page which will advance this action)
		 */
		this.pointerStr = this.runnerController.getPointerString(
			this.pointer,
			this.context
		);

		/**
		 * Request any queued inputs from the input controller.
		 * If the input controller can't find an Input which corresponds to anything on the page,
		 * nothing will happen. If there is, it will simulate it to advance the script.
		 */
		if (this.inputController) {
			this.inputController.request();
		}
	}

	// TODO: This is a hack used by RenderPrimitive to get "center" property of parent body.
	// This needs a much better solution,
	getParent() {
		if (this.pointer && this.pointer.length > 0) {
			let parentPointer = this.pointer.slice(0, this.pointer.length - 3);
			if (this.runnerController) {
				return this.runnerController.findItemByPointer(parentPointer);
			}
		}
	}

	initializeAnalytics(options) {
		this.taPlaythrough =
			this.mainController.analyticsController.getPlaythrough();
		this.taItem = this.taPlaythrough.createItem({
			pointer: this.runnerController.getPointerString(this.pointer),
			context: this.context,
			type: this.model.type,
		});

		if (options && options.createTrial && this.taItem) {
			this.taTrial = this.taItem.createTrial();
		}

		const {onBypass, onAdvance} = this;
		this.onAdvance = ($anchor) => {
			if (this.taItem) {
				this.taItem.setCompleted();
			}
			onAdvance($anchor);
		};
		this.onBypass = ($anchor) => {
			if (this.taItem) {
				this.taItem.setCompleted();
			}
			onBypass($anchor);
		};
	}
}
